import Empty from '@/views/Empty';
import LocationAccuracy from '@/views/pages/location_accuracy/Index';

export default {
  path: 'location_accuracy',
  component: Empty,
  meta: {},
  children: [
    {
      path: '',
      name: 'Location Accuracy',
      component: LocationAccuracy,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/location_accuracy.js